/* 07/10/2026 (multidioma fase 2): textos desde window.N1T; los enlaces se reconocen en español o en el texto traducido de la clave (n1.pdp.lk_*).
   N1 · Ficha de producto:
   1) los popups de tallas nunca quedan ocultos: la rutina que esconde el bloque suelto de
      "Guía de tallas" podía ocultar el popup o CUALQUIER contenedor suyo
   2) "Guía de tallas" en las preguntas → popup propio (#n1k-gsolo)
   3) "Personalización de guantes" en las preguntas → popup de personalización, enriquecido
   4) acordeones: al abrir uno se cierra el anterior, en toda la web */
(function(){
if(window.N1GpopFix)return;window.N1GpopFix=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
function esc(x){return String(x).replace(/[.*+?^${}()|[\]\\]/g,'\\$&')}
function rx(es,k){var t=T(k,es);return new RegExp(esc(es)+(t.toLowerCase()!==es.toLowerCase()?'|'+esc(t.toLowerCase()):''),'i')}

/* ---- 1. desocultar popups y todos sus contenedores ---- */
function unhide(){
  ['n1k-kpop','n1k-gpop','n1k-gsolo','n1-pop-ship','n1-pop-perso'].forEach(function(id){
    var p=document.getElementById(id);if(!p)return;
    var el=p;
    while(el&&el!==document.body){
      if(el.classList&&el.classList.contains('n1-hidden-blk'))el.classList.remove('n1-hidden-blk');
      el=el.parentElement;
    }
    p.querySelectorAll('.n1-hidden-blk').forEach(function(x){x.classList.remove('n1-hidden-blk')});
  });
}
/* ---- 2 y 3. popups desde las preguntas ---- */
function openById(id){
  unhide();
  var g=document.getElementById(id);if(!g)return false;
  g.classList.add('on');document.documentElement.classList.add('n1k-lock');return true;
}
function closeAll(){
  ['n1k-gsolo','n1-pop-perso'].forEach(function(id){var p=document.getElementById(id);if(p)p.classList.remove('on')});
  document.documentElement.classList.remove('n1k-lock');
}
function enrichPerso(){
  var p=document.getElementById('n1-pop-perso');if(!p||p.dataset.n1x)return;
  var ul=p.querySelector('ul');if(!ul)return;
  p.dataset.n1x=1;
  var a=document.createElement('li');a.className='ok';a.textContent=T('n1.perso.li5','Hasta 15 caracteres por guante.');ul.appendChild(a);
  var b=document.createElement('li');b.className='no';b.textContent=T('n1.perso.li6','Al fabricarse a medida, los guantes personalizados no admiten cambio ni devolución.');ul.appendChild(b);
}
document.addEventListener('click',function(e){
  var solo=document.getElementById('n1k-gsolo');
  if(solo&&(e.target===solo||e.target.closest('[data-gsclose]'))){closeAll();return}
  var perso=document.getElementById('n1-pop-perso');
  if(perso&&perso.classList.contains('on')&&(e.target===perso||e.target.closest('#n1-pop-perso .n1-pop__x'))){closeAll();return}
  if(e.target.closest('[data-gopen]')){unhide();return}
  var a=e.target.closest('a');if(!a)return;
  if(a.closest('.n1k-kpop,.n1a-nav,.n1-pop'))return;
  var href=a.getAttribute('href')||'',txt=(a.textContent||'').toLowerCase();
  if(href.indexOf('guia-de-tallas-guantes-de-portero')>-1||(a.classList.contains('n1-plk')&&(/guía de tallas|guia de tallas/.test(txt)||rx('guía de tallas','n1.pdp.lk_size').test(txt)))){
    if(openById('n1k-gsolo')){e.preventDefault();e.stopImmediatePropagation()}return;
  }
  if(href.indexOf('/pages/personalizacion')>-1||(a.classList.contains('n1-plk')&&rx('personalización de guantes','n1.pdp.lk_perso').test(txt))){
    enrichPerso();
    if(openById('n1-pop-perso')){e.preventDefault();e.stopImmediatePropagation()}return;
  }
},true);
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});

/* ---- 4. acordeones: solo uno abierto a la vez, en toda la web ---- */
document.addEventListener('toggle',function(e){
  var d=e.target;
  if(!d||d.tagName!=='DETAILS'||!d.open)return;
  var group=d.parentElement;
  /* subimos hasta el contenedor que agrupa varios acordeones hermanos */
  var guard=0;
  while(group&&guard<4&&group.querySelectorAll(':scope > details, :scope > * > details').length<2){group=group.parentElement;guard++}
  if(!group)group=document;
  group.querySelectorAll('details[open]').forEach(function(o){
    if(o!==d&&!o.contains(d)&&!d.contains(o))o.open=false;
  });
},true);

function run(){unhide();enrichPerso()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);
setTimeout(run,600);setTimeout(run,1600);setTimeout(run,3000);
new MutationObserver(function(){clearTimeout(window.__n1gp);window.__n1gp=setTimeout(unhide,200)}).observe(document.documentElement,{attributes:true,attributeFilter:['class'],subtree:true});
})();